<template>
  <v-app class="scrollbar-hidden" v-if="!viewRequiresAuth()">
    <router-view></router-view>
  </v-app>

  <v-app class="scrollbar-hidden" v-else>
    <EmployeeBottomNav v-if="usesBottomNav"></EmployeeBottomNav>
    <Sidebar v-else></Sidebar>

    <v-app-bar class="elevation-0" dense app>
      <Header></Header>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Sidebar from "@/components/Sidebar.vue";
import EmployeeBottomNav from "@/components/EmployeeBottomNav.vue";
import { authService } from "@/libs/ws/authService";

export default {
  name: "App",
  components: { Sidebar, Header, EmployeeBottomNav },
  data: () => ({}),
  computed: {
    usesBottomNav() {
      return this.$vuetify.breakpoint.smAndDown && authService.isEmployeeUser();
    },
  },
  created() {
    document.title = "SyscoreHR - IngeniAR";
  },
  mounted() {
    /*  this.$i18n.locale = "en"; */
    window.document.title = "SyscoreHR - IngeniAR";
  },
  methods: {
    viewRequiresAuth() {
      return this.$route.matched.some((record) => record.meta.requiresAuth && !record.meta.fullscreen);
    },
  },
};
</script>
